import React, {Component} from 'react'

export class NoPage extends Component {
    render() {
        return (
            <div>Page does not exists. Please ensure you are on the correct site or passed the correct booking id.</div>
        )
    }
}
